import Typography from '@/components/Typography';
import { TextStyles } from '@/constants';
import styled from 'styled-components';

export const ToggleItemContainer = styled.div(({ theme }) => ({
  gap: theme.spacing[8],

  '&:not(:first-child)': {
    paddingTop: theme.spacing[16],
  },
  '&:not(:last-child)': {
    paddingBottom: theme.spacing[16],
    borderBottom: `1px solid ${theme.colors.pressedBlack}`,
  },
}));

export const ToggleItemContent = styled.div(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  color: theme.colors.blue,
}));

export const TextContainer = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[4],
  wordBreak: 'break-word',
}));

export const Title = styled(Typography).attrs({
  variant: TextStyles['Body Text Small'],
})(({ theme }) => ({
  color: theme.colors.highEmphasisBlack,
  marginRight: theme.spacing[8],
  wordBreak: 'break-all',
  display: '-webkit-box',
  WebkitLineClamp: 1,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
}));

export const SubText = styled(Typography).attrs({
  variant: TextStyles['Body Text Small'],
})(({ theme }) => ({
  color: theme.colors.mediumEmphasisBlack,
}));
